function sizeSorting(sizes) {
  let newArray = new Array();
  let temp = [
    "XS",
    'XS- 32"',
    "XS - 32",
    "XS/S",
    "XS-M",
    "S",
    'S- 34"',
    "S - 34",
    "S/M",
    "M",
    'M- 36"',
    "M - 36",
    "M/L",
    "L",
    'L- 38"',
    "L - 38-40",
    "L/XL",
    "L-XXL",
    "XL/XXL",
    "One Size",
  ];
  for (let j = 0; j < temp.length; j++) {
    for (let k = 0; k < sizes.length; k++) {
      if (sizes[k].key == temp[j]) newArray.push(sizes[k]);
    }
  }
  return newArray;
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      payload.common.lazyDOMConfig.searchInputIdentifiers = [];
      let sortArray = payload.search.configs.sorts.configs;
      sortArray.splice(1, 0, {
        label: "Best Selling",
        field: "product_wizzy-best-selling_sortOrder:float",
        order: "asc",
      });

      payload.search.configs.general.includeOutOfStock = false;

      payload.common.lazyDOMConfig.searchInputIdentifiers.push({
        dom: "#Search",
        type: "search",
      });
      wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible = true;
      window.wizzyConfig.search.configs.facets.leftFacets.defaultCollapsed = true;
      payload.filters = {
        configs: {
          keepOpenedInMobileAfterApply: true,
          displayAsDrawer: true,
          keepOpenedInDesktopAfterApply: true,
        },
      };
      payload["search"]["configs"]["pagination"]["infiniteScrollOffset"] = {
        desktop: 2000,
        mobile: 3000,
      };
      return payload;
    }
  );

  let newDiv = document.getElementById("wizzy-search-results-product-new").text;
  let oldDiv = document.getElementById("wizzy-search-results-product");
  oldDiv.text = newDiv;

  const search = document.getElementById("Search");
  search.addEventListener("click", () => {
    if (screen.width < 768) {
      document
        .getElementsByClassName("wizzy-search-form-wrapper")[0]
        .classList.add("mobileTapped");
      document
        .getElementsByClassName("popup-navigation__close cursor-pointer")[0]
        .click();
      document
        .getElementsByClassName("input-text search-query wizzy-search-input")[0]
        .click();
    }
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      if (screen.width < 768) {
        document.getElementsByClassName("wizzy-search-back")[0].click();
      }
      if ($(".popup__body.show").first().length) {
        document.getElementsByClassName("search__close")[0].click();
      }
      return payload;
    }
  );

  document.getElementById("Search").addEventListener("click", () => {
    if (screen.width > 1000) {
      //   document
      //     .getElementsByClassName("header__btn-search")[0]
      //     .querySelector("i")
      //     .click();
    }
  });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      console.log(payload,"============>payload")
     if (Array.isArray(payload.filters.facets)) {
    payload.filters.facets.forEach((facet) => {
        if (facet.key === 'product_saree_type_custom_1') {
            facet.key = 'product_saree_type_custom';
        }
    });
}

      
      if (
        window.location.pathname.split("/")[2] === "blouse" &&
        window.location.pathname.split("/").includes("collections")
      ) {
        payload.filters.categories = ["blouse"];
      }
      // replaceObject(payload.filters.sort, {
      //    "field": "product_published_at:datetime",
      //    "order": "desc"
      // }, {
      //    "field": "createdAt",
      //    "order": "desc"
      // });

      // if (
      //   window.location.pathname.split("/")[2] === "clearance" &&
      //   window.location.pathname.split("/").includes("collections")
      // ) {
      //   // console.log("CLEARANCE ::::",payload.filters);
      //   // if(payload.filters.facets.)
      //   if (Array.isArray(payload.filters.facets)) {
      //     payload.filters.facets.forEach((facet) => {
      //       if (facet.key === "product_Category_tags") {
      //         facet.key = "product_Category_clearance_tags";
      //       }
      //     });
      //   }
      // }

      console.log(payload);
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      let facets = data.response.payload.facets;
      for (let i = 0; i < facets.length; i++) {
        if (facets[i].key == "product_Size" && facets[i].data.length > 0) {
          let sizes = facets[i].data;
          let updatedArray = sizeSorting(sizes);
          facets[i].data = updatedArray;
        }
      }
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((item) => {
        if (typeof item.attributes !== "undefined") {
          item.attributes.forEach((attr) => {
            if (attr.id === "product_variant_ids") {
              item.url = `${item.url}?variant=${attr.values[0].value[0]}`;
              item.id = attr.values[0].value[0];
            }
            if (attr.id === "product_handle") {
              item.handle = attr.values[0].value[0];
            }
            if (attr.id === "product_reviews_spr") {
              item.reviews = attr.values[0].value[0];
            }
            if (attr.id === "product_product_type") {
              item.productType = attr.values[0].value[0];
            }
          });
        }
      });
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      if ($(".wizzy-result-product").length === 1) {
        $(".wizzy-selected-facet-list").css("margin-top", "50px");
      }
      if (
        document.getElementsByClassName("popup")[0].classList.contains("show")
      ) {
        document.getElementsByClassName("search__close")[0].click();
      }

      let array = document.getElementsByClassName("disabled");

      for (let i = 0; i < array.length; i++) {
        array[i].addEventListener("click", function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
      }

      $(".wizzy-result-product").each(function () {
        var $thisProduct = $(this);
        var reviewsContent = $thisProduct.find("#wizzy-reviews").val();
        $thisProduct.find(".product-collection__reviews").html(reviewsContent);
      });

      return payload;
    }
  );
};

document.getElementById("Search").addEventListener("focus", function () {
  if (window.location.pathname === "/search") {
    document.getElementsByClassName(".header__btn-search")[0].click();
  }
});

$(document).ready(function () {
  $("body").on("click", ".header__btn-search", function (e) {
    if ($(window).width() < 768) {
      e.preventDefault();
      $("#Search").click();
      $(this).get(0).css("pointer-events", "none!important");
      return false;
    }
  });
  $(".js-currencies-list li").on("click", function () {
    setTimeout(() => {
      window.location.reload();
    }, 100);
  });
  const set_currency_value = (payload) => {
    if (getCookie("currency") !== "") {
      payload.currency = getCookie("currency");
      window.wizzyConfig.store.currency = {
        code: getCookie("currency"),
        symbol: curruncy_symbols[getCookie("currency")],
      };
    } else {
      payload.currency = "INR";
    }
    return payload;
  };
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      payload = set_currency_value(payload);
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
       payload.facets.forEach((facet)=>{
        
        if(facet.key=='product_saree_type_custom_1')
          facet.key='product_saree_type_custom'
       })

      payload = set_currency_value(payload);
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      payload = set_currency_value(payload);
      return payload;
    }
  );
});
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const curruncy_symbols = {
  INR: "₹",
  USD: "$",
  EUR: "€",
  GBP: "£",
  AUD: "A$",
};

function replaceObject(array, targetObject, replacementObject) {
  for (let i = 0; i < array.length; i++) {
    if (
      array[i].field === targetObject.field &&
      array[i].order === targetObject.order
    ) {
      array[i] = replacementObject;
      break; // Stop searching after replacement
    }
  }
}
